import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

function ImageGrid({ imageUrls = [] }) {
  const [open, setOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  if (!imageUrls.length) return null;

  const handleClick = (idx) => {
    setPhotoIndex(idx);
    setOpen(true);
  };

  const slides = imageUrls.map(url => ({ src: url }));

  return (
    <div
      style={{
        background: "#f8f9fa",
        padding: 20,
        borderRadius: 8,
        marginBottom: 20
      }}
    >
      <div>
        {imageUrls.map((url, idx) => {
          return (
            <div key={idx}>
              <img
                src={url}
                alt={`uploaded-${idx}`}
                title="Click to view"
                onClick={() => handleClick(idx)}
                style={{
                  display: "block",
                  width: "50%",
                  margin: "0 auto",
                  height: "auto",
                  objectFit: "contain",
                  borderRadius: 10,
                  boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                  cursor: "pointer",
                  transition: "transform 280ms ease, box-shadow 280ms ease",
                  transform: "scale(1)"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.02)";
                  e.currentTarget.style.boxShadow = "0 12px 32px rgba(0,0,0,0.25)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.2)";
                }}
              />
            </div>
          );
        })}
      </div>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={slides}
        index={photoIndex}
        carousel={{ finite: true }}
        controller={{ closeOnBackdropClick: true }}
        render={{
          buttonPrev: () => null,
          buttonNext: () => null,
        }}
      />
    </div>
  );
}

export default ImageGrid;
